import { PaymentGateway } from "types/payments";

export type StripePaymentMethod = "CC" | "ACH" | "GP" | "AP" | "CAPP" | "AMZP";

const getNonEmptyKey = (key: unknown): string | null => {
  if (typeof key !== "string") return null;

  const normalizedKey = key.trim();
  return normalizedKey || null;
};

const getGatewayPermission = (
  paymentPermission: any,
  method: StripePaymentMethod
) => {
  switch (method) {
    case "CC":
      return paymentPermission?.cc_gateway_name;
    case "ACH":
      return paymentPermission?.ach_gateway_name;
    case "GP":
      return paymentPermission?.gp_gateway_name;
    case "AP":
      return paymentPermission?.ap_gateway_name;
    case "CAPP":
      return paymentPermission?.capp_gateway_name;
    case "AMZP":
      return paymentPermission?.amzp_gateway_name;
  }
};

// The key must come from the gateway the API resolved for this account. A
// build-time default belongs to a different Stripe account, so a PaymentMethod
// created with it cannot be charged ("No such PaymentMethod").
export const resolveStripePublishableKey = (
  paymentPermission: any,
  method: StripePaymentMethod
): string | null => {
  let legacyPermissionKey: unknown;

  switch (method) {
    case "CAPP":
      legacyPermissionKey = paymentPermission?.cash_app_pay_key;
      break;
    case "AMZP":
      legacyPermissionKey = paymentPermission?.amazon_pay_key;
      break;
  }

  return (
    getNonEmptyKey(getGatewayPermission(paymentPermission, method)?.key) ||
    getNonEmptyKey(legacyPermissionKey)
  );
};

// True when the gateway is Stripe but the API sent no publishable key, so the
// Stripe form cannot be loaded and the payment must be blocked.
export const isStripeKeyMissing = (
  paymentPermission: any,
  method: StripePaymentMethod
): boolean =>
  getGatewayPermission(paymentPermission, method)?.name ===
    PaymentGateway.STRIPE &&
  !resolveStripePublishableKey(paymentPermission, method);

export const STRIPE_CARD_UNAVAILABLE_MESSAGE =
  "Card payments are unavailable right now. Please refresh the page and try again, or choose another payment method.";
